module.exports = __webpack_public_path__ + "img/cns_email_android1.c8e12a37.png";